import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';

const Footer = () => {
  const theme = useTheme();
  
  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '40px',
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
    >
      <Typography variant="body2" fontSize={12} sx={{ color: 'white', textAlign: 'center' }}>
        &copy; Copyright 2024-25 - 
        <Link
          href="https://www.OmneVu.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: 'white', textDecoration: 'none', ml: 0.5 }}
        >
          www.OmneVu.com
        </Link>
        <Typography component="span" sx={{ mx: 1, color: 'white' }}>|</Typography>
        By using or viewing this website or app you are governed by these 
        <Link
          href="/tnc"
          sx={{ color: 'white', textDecoration: 'underline', ml: 0.5 }}
        >
          Terms & Conditions and Privacy Policy
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;

